import React from 'react';
import { Container } from '../../components/ui/Primitives';
import { Button } from '../../components/ui/Button';
import { inputClass } from '../../components/ui/Field';
import { Seo } from '../../components/Seo';
import { useAcademy } from '../../context/Academy';
import { useAcademyHub } from '../../context/AcademyHub';
import { timeAgo } from '../../utils/academyFormat';

/** The learner's side of one-to-one messages with Academy instructors. */
export function AcademyMessages() {
  const {
    state
  } = useAcademy();
  const {
    hub,
    messageStaff,
    markConversationRead
  } = useAcademyHub();
  const [draft, setDraft] = React.useState('');
  const email = state.learner?.email ?? '';
  const thread = hub.messages.filter(m => m.learnerEmail === email);
  React.useEffect(() => {
    if (email) markConversationRead(email, 'learner');
  }, [email, thread.length, markConversationRead]);
  if (!state.learner) {
    return <Container className="py-20" data-id="element-1852" data-mp="3d6zlhl3fkeet">
        <h1 className="font-display text-[30px] text-ink" data-id="element-1853" data-mp="3d5wrv5eq3xv7">Messages</h1>
        <p className="mt-3 text-[16px] text-body" data-id="element-1854" data-mp="360va4t076m02">Create a free account to receive messages from your instructors.</p>
        <Button to="/academy/dashboard" className="mt-6" data-id="element-1855" data-mp="313vbv49lanji">
          Get started
        </Button>
      </Container>;
  }
  const send = (event: React.FormEvent) => {
    event.preventDefault();
    if (!draft.trim()) return;
    messageStaff(draft);
    setDraft('');
  };
  return <>
      <Seo title="Messages, Cavalla Academy" description="Messages from your instructors." path="/academy/messages" noIndex data-id="element-1856" data-mp="2nd9rfb4hm5ji" />
      <Container className="max-w-[760px] py-12 sm:py-16" data-id="element-1857" data-mp="2ieyh6zaa5t0r">
        <h1 className="font-display text-[30px] leading-tight text-ink sm:text-[38px]" data-id="element-1858" data-mp="2deaj5tnmwbx1">Messages</h1>
        <p className="mt-2 text-[15px] text-body" data-id="element-1859" data-mp="28fppye6susi3">Your instructors can write to you here about your courses. Replies go to the Academy team.</p>

        <ol aria-live="polite" className="mt-8 space-y-4 border-t border-line pt-6" data-id="element-1860" data-mp="6n1krzalhuzo">
          {thread.length ? thread.map(m => <li key={m.id} className={`flex ${m.from === 'learner' ? 'justify-end' : 'justify-start'}`} data-id="element-1861" data-mp="212hvt2cj3g2n">
                <div className={`max-w-[85%] rounded-md px-4 py-3 text-[15px] ${m.from === 'learner' ? 'bg-gold text-charcoal' : 'border border-line bg-panel text-ink'}`} data-id="element-1862" data-mp="25vkqxewyexky">
                  <p className="whitespace-pre-line" data-id="element-1863" data-mp="1w3f2ug9tp0b1">{m.body}</p>
                  <p className={`mt-1.5 text-[12px] ${m.from === 'learner' ? 'text-charcoal/70' : 'text-muted'}`} data-id="element-1864" data-mp="2jtrgm7rr1r9j">
                    {m.from === 'learner' ? 'You' : `${m.senderName}, Academy team`} · {timeAgo(m.at)}
                  </p>
                </div>
              </li>) : <li className="py-10 text-center text-[15px] text-muted" data-id="element-1865" data-mp="2euei2primvr4">No messages yet.</li>}
        </ol>

        <form onSubmit={send} className="mt-8 rounded-md border border-line bg-panel p-4" data-id="element-1866" data-mp="zdeegidd8lu9">
          <label htmlFor="learner-reply" className="text-[14px] font-medium text-ink" data-id="element-1867" data-mp="13g0yvy7pj4hf">
            {thread.length ? 'Reply' : 'Write to the Academy team'}
          </label>
          <textarea id="learner-reply" rows={3} value={draft} onChange={e => setDraft(e.target.value)} className={`${inputClass} mt-2`} data-id="element-1868" data-mp="vxtezegyrutm" />
          <div className="mt-3 flex justify-end" data-id="element-1869" data-mp="10v3a9ar1b0pd">
            <Button type="submit" disabled={!draft.trim()} data-id="element-1870" data-mp="10wedn9gki6fy">
              Send
            </Button>
          </div>
        </form>
      </Container>
    </>;
}